import * as z from 'zod';
import { extractionStatusSchema, ExtractionStatus, extractionErrorTypeSchema } from '../../../enums.mjs';
import { fileId } from '../../opaque.mjs';
import { ApplicationExtractionOutput } from './application-extraction-output.mjs';

var ApplicationExtractionResultPayload;
(function (ApplicationExtractionResultPayload) {
    ApplicationExtractionResultPayload.schema = z.object({
        fileId: fileId,
        status: extractionStatusSchema.extract([ExtractionStatus.Completed, ExtractionStatus.Partial]),
        processingSessionId: z.string().nullable(),
        output: ApplicationExtractionOutput.optional(),
    });
})(ApplicationExtractionResultPayload || (ApplicationExtractionResultPayload = {}));
var ApplicationExtractionFailurePayload;
(function (ApplicationExtractionFailurePayload) {
    ApplicationExtractionFailurePayload.schema = z.object({
        fileId: fileId,
        status: z.literal(ExtractionStatus.Failed),
        errorType: extractionErrorTypeSchema,
        errorMessage: z.string(),
    });
})(ApplicationExtractionFailurePayload || (ApplicationExtractionFailurePayload = {}));
var ApplicationExtractionWebhookPayload;
(function (ApplicationExtractionWebhookPayload) {
    ApplicationExtractionWebhookPayload.schema = z.discriminatedUnion("status", [
        ApplicationExtractionResultPayload.schema,
        ApplicationExtractionFailurePayload.schema,
    ]);
})(ApplicationExtractionWebhookPayload || (ApplicationExtractionWebhookPayload = {}));

export { ApplicationExtractionFailurePayload, ApplicationExtractionResultPayload, ApplicationExtractionWebhookPayload };
